import { Progress, Typography } from "@/components/ui";
import React from "react";

interface HateCircularProps {
  sentiment?: number;
}

interface CircularProgressWithLabelProps {
  value: number;
}

function CircularProgressWithLabel({ value }: CircularProgressWithLabelProps) {
  const getColor = (): "error" | "primary" | "success" => {
    if (value < 20) return "error";
    if (value < 80) return "primary";
    return "success";
  };

  const colorMap = {
    error: "text-error",
    primary: "text-accent",
    success: "text-success",
  };

  const bgColorMap = {
    error: "bg-error",
    primary: "bg-accent",
    success: "bg-success",
  };

  const color = getColor();

  return (
    <div className="relative inline-flex items-center justify-center p-2">
      {/* Background circle */}
      <svg className="w-10 h-10 transform -rotate-90">
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="currentColor"
          strokeWidth="4"
          fill="none"
          className="text-surface-secondary"
        />
        <circle
          cx="20"
          cy="20"
          r="16"
          stroke="currentColor"
          strokeWidth="4"
          fill="none"
          strokeDasharray={`${(value / 100) * 100.53} 100.53`}
          className={colorMap[color]}
          strokeLinecap="round"
        />
      </svg>
      {/* Center text */}
      <div className="absolute">
        <Typography variant="text-xs" className={`font-medium ${colorMap[color]}`}>
          {Math.round(value)}%
        </Typography>
      </div>
    </div>
  );
}

const HateCircular: React.FC<HateCircularProps> = ({ sentiment }) => {
  return <CircularProgressWithLabel value={sentiment! * 100} />;
};

export default HateCircular;
